module.exports = __webpack_public_path__ + "img/void_portal_small.add4a041.png";